import React from 'react'
import Box from '@mui/material/Box';
import RowDetailLoadingSkeleton from '../skeletons/RowDetailLoadingSkeleton';
import Stack from '@mui/material/Stack';
import { JSONToTable } from './JSONToTable';
// import './JSONToHTMLTable.css'

function RowDetail({ data, rowDetailsKeysToExclude, keys, index, loading }) {

    if (data == null || data == undefined) return <RowDetailLoadingSkeleton variant={"rectangular"} marginx={1} marginy={8} count={5} />

    const renderTable = () => {
        try {
            return <JSONToTable data={data} keysToExclude={rowDetailsKeysToExclude} />
        } catch (error) {
            return <div>We hit a snag.. Try refreshing your page or reach out to admin. </div>
        }
    }


    return (

        <Stack spacing={4}>
            <Box sx={{
                display: 'flex',
                pt: 2
            }} />
            {renderTable()}
            <Box sx={{ display: 'flex', pt: 2 }} />
        </Stack>

    )
}

export default RowDetail